module.exports = __webpack_public_path__ + "img/postback-step-1.ru.cd5a7697.jpg";